export default {
  id: 'AccountSettings',
  code: 'CN',
  text: {
    'Account username has been changed successfully!': '登录手机号更改成功!',
    'This phone number has been used!':'此手机号已被使用!',
    'Invalid pin!':'验证码无效!',
    'Failed to changed account username!': '更改登录手机号失败!',
    'Account password has been changed successfully!': '修改密码成功!',
    'Invalid current password': '老密码错误',
    'New password is too short': '新密码太短',
    'New password can not be the same as the current passowrd': '新老密码不能一样',
    'New password can not be the same as the username': '新密码不能喝用户名一样',
    'Failed to change password!': '修改密码失败',
    'You are unable to subscribe to this plan. If you would like to change, please contact our support team.': '您现有的计划不支持改变成此计划，如果有需要，请联系客服人员。',
    'Are you sure to change the username?': '您是否确定更改登录手机号?',
    'Are you sure to change the password?': '您是否确定更改登录密码?',
    'Are you sure to change the email?': '您是否确定更改邮箱?',
    'Email has been changed successfully!': '邮箱更改成功!',
    'This email has been used!': '此邮箱已被使用!',
    'Failed to change email!': '更改邮箱失败',
    'Credit card info has been updated successfully!': '更改信用卡信息成功!',
    'Phone number is invalid or has been used': '电话号码无效或此号码已被使用',
    'Failed to send verification code!': '发送验证码失败',
    'Phone Number': '手机号',
    'Update Phone Number': '更改手机',
    '6 digits': '6位数字',
    'Enter New Phone Number': '输入新手机号',
    'Enter Verification Code': '输入验证码',
    'Update': '更改',
    'Email': '邮箱',
    'Update Email': '更改邮箱',
    'Enter New Email': '输入新邮箱',
    'Password': '密码',
    'Update Password': '更改密码',
    'Enter Current Password': '输入当前密码',
    'Enter New Password': '输入新密码',
    'At least 6 characters': '至少6个字符',
    'Active Card': '已绑定信用卡',
    'Card number': '卡号',
    'Expiry date': '有效日期',
    'Account Subscription': '账户订阅',
    'Monthly': '月付',
    'Yearly': '年付',
    'Plan Name': '计划名称',
    'Trial End': '试用结束日期',
    'Account Settings': '账户设置',
    'Price': '价格',
    'Billing Cycle': '收费周期',
    'Next Billing Date': '下次扣款日期',
    'Current Plan': '当前计划',
    'Additional campus costs $79 per month': '每个额外校区, 79美元/月',
    'Update Card': '更改信用卡',
    "All payments are processed through Stripe. The connection is secure and encrypted. We do not collect any of your information.": "所有付款都通过 Stripe 处理。付款连接是安全并且加密的。我们不会收集您的任何信息。",
    'month per school': '每个学校一个月',
    'Privacy Policy': '隐私政策',
    'Free Trial': '免费试用版'
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/AccountSettings/locale.js